import type { TablePaginationConfig } from 'antd'

export interface TablePaginationProps {
  current: number
  pageSize: number
  total: number
  onChange?: (page: number, pageSize: number) => void
  showSizeChanger?: boolean
  showQuickJumper?: boolean
  showTotal?: (total: number, range: [number, number]) => string
}

/**
 * 标准化的表格分页组件配置
 * 提供统一的分页器样式和功能
 */
export const createTablePagination = ({
  current,
  pageSize,
  total,
  onChange,
  showSizeChanger = true,
  showQuickJumper = true,
  showTotal = (total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`,
}: TablePaginationProps): TablePaginationConfig => {
  return {
    current,
    pageSize,
    total,
    showSizeChanger,
    showQuickJumper,
    showTotal,
    onChange,
  }
}

/**
 * 默认的表格分页配置
 * 可以直接用于不需要自定义的场景
 */
export const getPagination = (
  current: number,
  pageSize: number,
  total: number,
  onChange?: (page: number, pageSize: number) => void,
): TablePaginationConfig => {
  return createTablePagination({
    current,
    pageSize,
    total,
    showSizeChanger: true,
    showQuickJumper: true,
    onChange,
  })
}
